export default (client, defaultParams) => ({
  getTenant: (payload) => (
    client('/user/tenant', {
      method: 'GET',
      data: payload,
      params: {
        ...defaultParams,
      },
    })
  ),
  login: (payload) => (
    client('/login', {
      method: 'POST',
      data: payload,
      params: {
        ...defaultParams,
      },
    })
  ),
  forgetPassword: (payload) => (
    client('/user/forget_password', {
      method: 'POST',
      data: payload,
      params: {
        ...defaultParams,
      },
    })
  ),
  changePassword: (payload) => (
    client('/user/change_password', {
      method: 'PUT',
      data: payload,
      params: {
        ...defaultParams,
      },
    })
  ),

  getMessage: (k) => {
    const messages = {
      no_login: 'Email o contraseña incorrecta',
    };
    return (messages[k] || k);
  },
});
